import {api} from "./api";
import {MODERATOR_PLACE} from "../mock/URLs";

export const getSosPlaces = async () => {
  try {
    const {data} = await api.get(MODERATOR_PLACE)
    return data
  } catch (e) {
    throw e
  }
}


export const createSosPlace = async (values: FormData) => {
  try {
    const {data} = await api.post(MODERATOR_PLACE, values)
    return data
  } catch (e) {
    throw e
  }
}

export const updateSosPlace = async (id: number, values) => {
  try {
    const {data} = await api.patch(`${MODERATOR_PLACE}${id}/`, values)
    return data
  } catch (e) {
    throw e
  }
}

export const getSosPlaceById = async (id: number) => {
  try {
    const {data} = await api.get(`${MODERATOR_PLACE}${id}/`)
    return data?.data;
  } catch (e) {
    throw e;
  }
}